import { cn } from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

// 24 при зазоре 3px: точки плотнее друг к другу (тридцать выходили бисером).
const DOTS = 24

/** Сколько точек закрасить: непустой остаток — хотя бы одна, иначе он выглядел бы нулём. */
const filledDots = (share: number): number =>
  share > 0 ? Math.max(1, Math.round(share * DOTS)) : 0

/** Ряд точек — остаток кредитов от последней покупки (`creditsShare`). */
export const CreditsDots = ({ share }: { share: number }) => {
  const m = useMessages(messages)
  const filled = filledDots(share)
  return (
    <div
      role="img"
      aria-label={m.creditsLeftShare(Math.round(share * 100))}
      className="grid auto-cols-fr grid-flow-col gap-[3px]"
    >
      {Array.from({ length: DOTS }, (_, i) => (
        <span
          // Точки — неподвижная шкала, не редактируемый список: индекс и есть их идентичность.
          key={i}
          className={cn('aspect-square rounded-full', i < filled ? 'bg-brand' : 'bg-foreground/10')}
        />
      ))}
    </div>
  )
}
